/**
 * Login actions
 */
import { WebRoute } from 'config/fe-routes';
import { dispatch } from 'store';

import { LOGIN_MODAL_OPEN, SET_LOGIN_MODAL_STORE_DATA } from '../action-types/login.action-types';

// eslint-disable-next-line import/prefer-default-export
export const openLoginModal = (isOpen: boolean, redirect?: WebRoute, referralCode?: string) =>
  dispatch({
    type: LOGIN_MODAL_OPEN,
    data: {
      isOpen,
      redirect,
      referralCode,
    },
  });

export const setLoginModalStoreData = (storeData: any) =>
  dispatch({
    type: SET_LOGIN_MODAL_STORE_DATA,
    data: {
      storeData,
    },
  });
